module.exports = __webpack_public_path__ + "img/IMG_7189_L_Black.e35c1d09.jpg";